import React, {useCallback, useEffect, useState} from 'react';
import {IconButton} from '@bonprix/design-system';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Constants} from '../view-constants';
import {useAppState} from '@core/scripts/modules/shoppingApp/appState.ts';

export default function BackToTopButton() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [visible]);

    const handleScroll = () => {
        const scrollPosition = document.documentElement.scrollTop;
        if (scrollPosition >= Constants.BACK_TO_TOP_SHOW_DISTANCE) {
            setVisible(true);
        } else if (scrollPosition <= Constants.BACK_TO_TOP_HIDE_DISTANCE) {
            setVisible(false);
        }
    };

    const appState = useAppState();
    const appSafeAreaBottom = appState?.metadata?.safeAreaInsets?.bottom ?? 0;

    const scrollToTop = useCallback(() => {
        Landmark.sendClickLandmark(Constants.LANDMARK_BACK_TO_TOP);
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    if (visible) {
        return (
            <div
                className={`article-overview__back-to-top`}
                style={{
                    marginBottom: appSafeAreaBottom,
                }}
            >
                <IconButton onClick={scrollToTop} variant="primary" icon="arrow-up" />
            </div>
        );
    } else {
        return <></>;
    }
}
